import React from 'react'
import './App.css';
import AppRoutes from './routes/Routes';

const App = () => {
  return <AppRoutes/>;
};

export default App;
